import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../components/services/auth.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';

interface Trade {
  value: string;
  label: string;
  icon: string;
  description: string;
}

@Component({
  selector: 'app-become-provider',
  templateUrl: './become-provider.component.html',
  styleUrls: ['./become-provider.component.css']
})
export class BecomeProviderComponent implements OnInit {
  step = 1;
  isLoading = false;
  errorMessage = '';

  selectedTrade = '';
  serviceArea = '';
  bio = '';
  phone = '';

  trades: Trade[] = [
    { value: 'electrician',   label: 'Electrician',        icon: 'electrical_services', description: 'Wiring, panels, lighting, EV chargers' },
    { value: 'plumber',       label: 'Plumber',            icon: 'plumbing',            description: 'Pipes, fixtures, drains, water heaters' },
    { value: 'carpenter',     label: 'Carpenter',          icon: 'handyman',            description: 'Framing, trim, decks, cabinets' },
    { value: 'general',       label: 'General Contractor', icon: 'construction',        description: 'Full project management & oversight' },
    { value: 'painter',       label: 'Painter',            icon: 'format_paint',        description: 'Interior & exterior painting, staining' },
    { value: 'hvac',          label: 'HVAC',               icon: 'ac_unit',             description: 'Heating, cooling, ductwork, ventilation' },
    { value: 'roofer',        label: 'Roofer',             icon: 'roofing',             description: 'Shingles, flat roofs, gutters, repairs' },
    { value: 'landscaper',    label: 'Landscaper',         icon: 'yard',                description: 'Lawn care, landscaping, irrigation' },
    { value: 'flooring',      label: 'Flooring',           icon: 'layers',              description: 'Hardwood, tile, carpet, vinyl installation' },
  ];

  currentUser: any = null;

  constructor(
    private authService: AuthService,
    private http: HttpClient,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.currentUser = this.authService.getCurrentUser();
    if (!this.currentUser) {
      this.router.navigate(['/auth']);
      return;
    }
    // Already a provider
    if (this.currentUser.role === 'provider') {
      this.router.navigate(['/provider-dashboard']);
    }
  }

  selectTrade(value: string): void {
    this.selectedTrade = value;
  }

  get selectedTradeLabel(): string {
    return this.trades.find(t => t.value === this.selectedTrade)?.label || '';
  }

  nextStep(): void {
    if (this.step < 3) this.step++;
  }

  prevStep(): void {
    if (this.step > 1) this.step--;
  }

  submit(): void {
    this.isLoading = true;
    this.errorMessage = '';

    const payload = {
      ...this.currentUser,
      role: 'provider',
      jobTitle: this.selectedTradeLabel,
      // API stores ServiceArea as a single string; an array fails model binding (400).
      serviceArea: this.serviceArea.split(',').map((s: string) => s.trim()).filter(Boolean).join(', '),
      bio: this.bio,
      phone: this.phone || this.currentUser.phone,
    };

    this.http.put<any>(`${environment.apiUrl}Users/${this.currentUser.id}`, payload).subscribe({
      next: (res) => {
        // The API returns a fresh token carrying the new provider role; keep it so
        // provider-only endpoints (Pro checkout, payouts) accept the next request.
        const updated = { ...this.currentUser, ...payload, token: res?.token || this.currentUser.token };
        this.authService.setCurrentUser(updated);
        this.isLoading = false;
        this.step = 4; // success step
      },
      error: (err) => {
        console.error('Failed to update user', err);
        this.errorMessage = err?.status === 401
          ? 'Your session expired. Please sign in again.'
          : "We couldn't save your provider profile. Please try again.";
        this.isLoading = false;
      }
    });
  }

  goToDashboard(): void {
    this.router.navigate(['/provider-dashboard']);
  }
}
